// extracted by mini-css-extract-plugin
export default {"container":"tab_container__7T9DH"};